import axios from 'axios'

export const getDatosNimPresusp = async (body: {}) => {
  const axiosUrl = '/getDatosNimPresusp'
  const { data } = await axios.post(axiosUrl, body)
  return data
}

export const validaCliente = async (documentNumber: string) => {
  const axiosUrl = '/preactivation/valida-cliente'
  const { data } = await axios.post(axiosUrl, {
    srfIdentificationNumber: documentNumber,
    srfIdentificationType: 'EXT'
  })
  return data
}

export const appServicePaises = async () => {
  const axiosUrl = '/appServiceMobile/paises'
  const { data } = await axios.post(axiosUrl)
  return data
}
export const createDocumentNom = async (body: {}) => {
  const axiosUrl = '/nominativity/CreateDoc' // CreateDoc grego service
  const { data } = await axios.post(`${axiosUrl}`, body)
  return data
}

export const signAndProcess = async (body: {}) => {
  const axiosUrl = '/nominativity/ProcessData' // ProcessData grego service
  const { data } = await axios({ method: 'post', url: `${axiosUrl}`, data: body, timeout: 120000 })
  return data
}
